import { Dispatch, SetStateAction, useEffect, useState } from "react";

export type ThemeMode = "light" | "dark";

export const THEME_PREFERENCE_KEY = "protea.theme-mode";
export const DEFAULT_THEME_MODE: ThemeMode = "light";

const isThemeMode = (value: string | null): value is ThemeMode => value === "light" || value === "dark";

export function readThemePreference(storage?: Storage | null): ThemeMode {
  try {
    const source = storage ?? (typeof window !== "undefined" ? window.localStorage : null);
    const value = source?.getItem(THEME_PREFERENCE_KEY) ?? null;
    return isThemeMode(value) ? value : DEFAULT_THEME_MODE;
  } catch {
    return DEFAULT_THEME_MODE;
  }
}

export function persistThemePreference(mode: ThemeMode, storage?: Storage | null): void {
  try {
    const target = storage ?? (typeof window !== "undefined" ? window.localStorage : null);
    target?.setItem(THEME_PREFERENCE_KEY, mode);
  } catch {
    // La preferencia local es opcional; el tema sigue funcionando durante la sesión.
  }
}

export function useThemePreference(): [ThemeMode, Dispatch<SetStateAction<ThemeMode>>] {
  const [themeMode, setThemeMode] = useState<ThemeMode>(() => readThemePreference());

  useEffect(() => {
    persistThemePreference(themeMode);
  }, [themeMode]);

  return [themeMode, setThemeMode];
}
